/**
 * Tracks whether the deck builder currently has unsaved changes, so actions
 * *outside* the builder (notably "Sign out" in the header) can warn before
 * discarding them. The builder publishes its state via setUnsavedGuard.
 */
let hasUnsaved = false;

export function setUnsavedGuard(v: boolean): void {
  hasUnsaved = v;
}

export function hasUnsavedChanges(): boolean {
  return hasUnsaved;
}

/** True if it's OK to proceed — no unsaved changes, or the user confirmed discarding. */
export function confirmLeaveUnsaved(
  message = 'You have unsaved changes to your deck. Sign out and discard them?',
): boolean {
  return !hasUnsaved || window.confirm(message);
}
